// @ts-nocheck
/* eslint-disable */

import React from 'react';
import EntityTable from 'app/components/CRUD/EntityTable';
import ApartmentIcon from '@mui/icons-material/Apartment';
import moment from 'moment';

const OrganisationBanksTable: React.FC = () => {
  const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';

  return (
    <EntityTable
      // ============ PAGE CONFIGURATION ============
      pageTitle="OrganisationBanks"
      pageIcon={ApartmentIcon}
      addButtonLabel="AddNewOrganisationBank"
      
      // ============ NAVIGATION URLs ============
      addPageUrl="/settlements/OrganisationBanks/new"
      viewPageUrl="/settlements/OrganisationBanks/:id"
      editPageUrl="/settlements/OrganisationBanks/:id/edit?came_from=all"
      
      // ============ API CONFIGURATION ============
      getApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/settlements/organisation-banks`}
      getApiMethod="GET"
      
      deleteApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/settlements/organisation-banks/:id`}
      deleteApiMethod="DELETE"
      
      // ============ RESPONSE CONFIGURATION ============
      responseDataPath="data.data.organisationBanks"
      responsePaginationPath="data.data.pagination"
      
      // ============ TABLE CONFIGURATION ============
      idField="id"
      columns={[
        {
          field: 'org_en_name',
          headerKey: 'OrganisationNameEnglish',
          align: 'center',
          render: (value, row) => (
            currentLanguageCode === 'en-us' ? row.org_en_name : row.org_ar_name
          ),
        },
        {
          field: 'bank_name_en',
          headerKey: 'BankName',
          align: 'center',
          render: (value, row) => (
            currentLanguageCode === 'en-us' ? row.bank_name_en : row.bank_name_ar
          ),
        },
        {
          field: 'account_name',
          headerKey: 'AccountName',
          align: 'center',
        },
        {
          field: 'account_number',
          headerKey: 'AccountNumber',
          align: 'center',
        },
        {
          field: 'iban',
          headerKey: 'IBAN',
          align: 'center',
        },
        {
          field: 'branch_name',
          headerKey: 'BranchName',
          align: 'center',
        },
        {
          field: 'financial_account_name',
          headerKey: 'FinancialAccount',
          align: 'center',
        },
        {
          field: 'created_at',
          headerKey: 'CreatedAt',
          align: 'center',
          render: (value) => value ? moment(value).format('DD/MM/YYYY HH:mm:ss') : '-',
        },
      ]}
      
      // ============ SEARCH CONFIGURATION ============
      searchQueryParam="search"
      searchPlaceholder="SearchOrganisationBankPlaceholder"
      searchInputWidth="390px"
      
      // ============ FILTER CONFIGURATION ============
      filterFields={[
        {
          name: 'organisation_id',
          labelKey: 'Organisation',
          type: 'dropdown',
          apiUrl: `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/faremedia/get_organisations`,
          apiMethod: 'GET',
          dataPath: 'data.data',
          optionConfig: {
            valueField: 'id',
            labelField: (item: any) => currentLanguageCode === 'en-us' ? item.en_name : item.ar_name,
          },
        },
        {
          name: 'bank_id',
          labelKey: 'Bank',
          type: 'dropdown',
          apiUrl: `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/settlements/banks`,
          apiMethod: 'GET',
          dataPath: 'data.data.banks',
          optionConfig: {
            valueField: 'id',
            labelField: (item: any) => currentLanguageCode === 'en-us' ? item.bank_name_en : item.bank_name_ar,
          },
        },
        {
          name: 'financial_account_id',
          labelKey: 'FinancialAccount',
          type: 'dropdown',
          apiUrl: `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/settlements/financial-accounts`,
          apiMethod: 'GET',
          dataPath: 'data.data.financialAccounts',
          optionConfig: {
            valueField: 'id',
            labelField: 'name',
          },
        },
      ]}
      
      // ============ PERMISSIONS ============
      subsystemName="OrganisationBanks"
      
      // ============ ACTIONS ============
      showAddButton={true}
      showActions={true}
      showEdit={true}
      showDelete={true}
      deleteConfirmationMessage="AreYouSureDeleteOrganisationBank"
    />
  );
};

export default OrganisationBanksTable;